import { render } from "./EditAlert.vue?vue&type=template&id=6d5d520c&ts=true"
import script from "./EditAlert.vue?vue&type=script&lang=ts"
export * from "./EditAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__